export const DOCUMENT_TYPE_SIMPLEVIEW_EVENT_CALENDAR_FRONTPAGE =
	'simpleviewEventCalendarFrontpage';
